module.exports = __webpack_public_path__ + "static/img/mb-07.944fd5c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/w11/mb-07.jpg
// module id = M6tC
// module chunks = 1